import styled from 'styled-components';
import InputMask from 'react-input-mask';

import theme from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  height: 45px;
  max-height: 45px;
  margin: 10px 0;
`;

export const Error = styled.span`
  position: absolute;
  top: calc(50% - 6px);
  right: 20px;
  font-size: 12px;
  color: ${theme.error};
  text-transform: uppercase;
`;

export const CustomInput = styled(InputMask)`
  display: flex;
  flex: 1;
  height: 45px;
  max-height: 45px;
  border-radius: 1px;
  border: 1px solid ${({ error }) => (error ? theme.error : theme.inputBorder)};
  padding: 0 20px;
  font-size: 16px;

  :focus {
    border: 1px solid
      ${({ error }) => (error ? theme.error : theme.inputActiveBorder)};

    background-color: ${theme.inputBackground};
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${theme.background};
  }

  :focus::placeholder,
  :focus::-webkit-input-placeholder {
    color: ${theme.secondary};
  }
`;
